
import { useState } from 'react';

export default function ProductInfo() {
  const [quantity, setQuantity] = useState(1);

  const handleQuantityChange = (delta: number) => {
    setQuantity(Math.max(1, quantity + delta));
  };

  return (
    <div className="space-y-6">
      {/* Product Title */}
      <div>
        <h1 className="text-3xl font-bold text-gray-900 mb-2">NVIDIA GeForce RTX 4070 그래픽카드</h1>
        <p className="text-gray-600">최신 Ada Lovelace 아키텍처 기반 고성능 게이밍 GPU</p>
      </div>

      {/* Price */}
      <div className="bg-gradient-to-br from-teal-50 to-emerald-50 rounded-2xl p-6">
        <div className="flex items-center justify-center">
          <span className="text-4xl font-bold text-teal-600">구매협의</span>
        </div>
        <p className="text-center text-sm text-gray-600 mt-3">
          견적 문의를 통해 최적의 가격을 안내해 드립니다
        </p>
      </div>

      {/* Key Specs */}
      <div className="space-y-3">
        <h3 className="font-bold text-gray-900 text-lg">핵심 사양</h3>
        <div className="grid grid-cols-2 gap-4">
          <div className="bg-white border border-gray-200 rounded-lg p-4">
            <div className="text-sm text-gray-600 mb-1">VRAM 용량</div>
            <div className="font-bold text-gray-900">12GB GDDR6X</div>
          </div>
          <div className="bg-white border border-gray-200 rounded-lg p-4">
            <div className="text-sm text-gray-600 mb-1">부스트 클럭</div>
            <div className="font-bold text-gray-900">2,475 MHz</div>
          </div>
          <div className="bg-white border border-gray-200 rounded-lg p-4">
            <div className="text-sm text-gray-600 mb-1">CUDA 코어</div>
            <div className="font-bold text-gray-900">5,888개</div>
          </div>
          <div className="bg-white border border-gray-200 rounded-lg p-4">
            <div className="text-sm text-gray-600 mb-1">TDP</div>
            <div className="font-bold text-gray-900">200W</div>
          </div>
        </div>
      </div>

      {/* Features */}
      <div className="bg-teal-50 rounded-xl p-6 border border-teal-100">
        <h3 className="font-bold text-gray-900 mb-3 flex items-center">
          <i className="ri-star-line text-teal-600 mr-2"></i>
          주요 특징
        </h3>
        <ul className="space-y-2 text-sm text-gray-700">
          <li className="flex items-start">
            <i className="ri-check-line text-teal-600 mr-2 mt-0.5 flex-shrink-0"></i>
            <span>DLSS 3 기술 지원으로 최대 4배 성능 향상</span>
          </li>
          <li className="flex items-start">
            <i className="ri-check-line text-teal-600 mr-2 mt-0.5 flex-shrink-0"></i>
            <span>레이 트레이싱 3세대 코어로 실시간 광선 추적</span>
          </li>
          <li className="flex items-start">
            <i className="ri-check-line text-teal-600 mr-2 mt-0.5 flex-shrink-0"></i>
            <span>4K 게이밍 및 크리에이터 작업에 최적화</span>
          </li>
          <li className="flex items-start">
            <i className="ri-check-line text-teal-600 mr-2 mt-0.5 flex-shrink-0"></i>
            <span>AV1 인코딩 지원으로 고품질 스트리밍</span>
          </li>
        </ul>
      </div>

      {/* Delivery & Warranty */}
      <div className="grid grid-cols-3 gap-4 text-sm">
        <div className="text-center p-4 bg-gray-50 rounded-lg">
          <i className="ri-truck-line text-2xl text-teal-600 mb-2"></i>
          <div className="font-medium text-gray-900">무료 배송</div>
          <div className="text-gray-600 text-xs mt-1">전국 배송</div>
        </div>
        <div className="text-center p-4 bg-gray-50 rounded-lg">
          <i className="ri-shield-check-line text-2xl text-teal-600 mb-2"></i>
          <div className="font-medium text-gray-900">3년 보증</div>
          <div className="text-gray-600 text-xs mt-1">제조사 보증</div>
        </div>
        <div className="text-center p-4 bg-gray-50 rounded-lg">
          <i className="ri-refresh-line text-2xl text-teal-600 mb-2"></i>
          <div className="font-medium text-gray-900">7일 교환</div>
          <div className="text-gray-600 text-xs mt-1">단순 변심</div>
        </div>
      </div>

      {/* Quantity & Purchase */}
      <div className="space-y-4 pt-6 border-t border-gray-200">
        <div className="flex items-center justify-between">
          <span className="font-medium text-gray-900">수량</span>
          <div className="flex items-center gap-3">
            <button
              onClick={() => handleQuantityChange(-1)}
              className="w-10 h-10 flex items-center justify-center border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors cursor-pointer"
            >
              <i className="ri-subtract-line text-gray-600"></i>
            </button>
            <span className="w-12 text-center font-medium text-gray-900">{quantity}</span>
            <button
              onClick={() => handleQuantityChange(1)}
              className="w-10 h-10 flex items-center justify-center border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors cursor-pointer"
            >
              <i className="ri-add-line text-gray-600"></i>
            </button>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <button className="py-4 bg-white border-2 border-teal-600 text-teal-600 rounded-lg font-bold hover:bg-teal-50 transition-colors whitespace-nowrap cursor-pointer">
            견적 문의
          </button>
          <button className="py-4 bg-teal-600 text-white rounded-lg font-bold hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer">
            구매하기
          </button>
        </div>
      </div>
    </div>
  );
}